const RECEIVE_ALL_OMNI_BRANDS_FOLLOWING = 'src/omniBrands/RECEIVE_ALL_OMNI_BRANDS_FOLLOWING' as const;

export default { RECEIVE_ALL_OMNI_BRANDS_FOLLOWING };
